import React from 'react'
import Moment from 'react-moment'
import { pascalCase, titleCase } from 'change-case'

import { StatusTag, DivText } from 'components'
import { getOptionTitle, numberFormat } from 'core/utilities'
import * as v from 'variables/styles'

export const typeOfBondOptions = [
  {
    key:1,
    value:'advancePayment',
    text:'Advance Payment'
  },
  {
    key:2,
    value:'performance',
    text:'Performance'
  },
  {
    key:3,
    value:'contract',
    text:'Contract'
  },
  {
    key:4,
    value:'product',
    text:'Product'
  },
  {
    key:5,
    value:'retention',
    text:'Retention'
  },
  {
    key:6,
    value:'facilityElectricityFleetCard',
    text:'Facility(Electricity/Fleet Card)'
  },
  {
    key:7,
    value:'other',
    text:'Other'
  },
]

export const referenceDocumentOptions = [
  { 
    key:1,
    value: 'contract', 
    text: 'Contract' 
  },
  { 
    key:2,
    value: 'poNumber', 
    text: 'Purchase Order Number' 
  }
]

export const requestTypeOptions = [
  { 
    key:1,
    value: 'new', 
    text: 'New' 
  },
  { 
    key:2,
    value: 'extend', 
    text: 'Extend' 
  }
]

export const requestForTypeOptions = [
  { 
    key:1,
    value: 'customer', 
    text: 'Customer' 
  },
  { 
    key:2,
    value: 'vendor', 
    text: 'Vendor' 
  }
]

export const search_statusOption = [
  { key: 0,value: '-', text: 'All Status' },
  {
    key:1,
    value:0,
    text:'Draft'
  },
  {
    key:2,
    value:100,
    text:'Not Start'
  }, 
  {
    key:3,
    value:200,
    text:'Active'
  },
  {
    key:4,
    value:201,
    text:'Extended'
  },
  {
    key:6,
    value:500,
    text:'Expired'
  },
  {
    key:6,
    value:900,
    text:'Returned'
  },
]

export const statusColor = {
  0: v.tagDraft,
  100: v.tagNew,
  200: v.tagInProgress,
  201: v.tagInProgress,
  500: v.tagReject,
  800: v.tagCanceled,
  900: v.tagCompleted
}

export const buttonColor = {
  Approve:'green',
  Accept:'green',
  Submit:'green',
  Resubmit:'green',
  Revise:'orange',
  Reject:'red',
  Cancel:'red',
}

export const exportColumn = [
  { key: 'statusName', label: 'Status' },
  { key: 'documentNumber', label: 'Document No.' },
  { key: 'documentType', label: 'Document Type' },
  { key: 'bgOriginalDocNumber', label: 'Original BG.' },
  { key: 'bgRequester', label: 'Requester (BG Request)' },
  { key: 'bgRequestDocNumber', label: 'Request No.' },
  { key: 'title', label: 'Title' },
  { key: 'remark', label: 'BG Remark' },
  { key: 'requestForName', label: 'Vendor/Customer' },
  { key: 'companyName', label: 'Company Code' },
  { key: 'typeOfBond', label: 'Type of Bond' },
  { key: 'typeOfBondOther', label: 'Other Type of Bond' },
  { key: 'amount', label: 'Amount (THB)' },
  // { key: 'refChange', label: 'Reference (Change)' },
  // { key: 'refExtend', label: 'Reference (Extend)' },
  // { key: 'newBg', label: 'New BG' },
  { key: 'bankGuaranteeNumber', label: 'Bank Guarantee No.' },
  { key: 'bankOwner', label: 'Bank Owner' },
  { key: 'startDate', label: 'Start Date' },
  { key: 'dueDate', label: 'Due Date' },
  { key: 'isNoExpireDate', label: 'No Expire Date' },
  { key: 'returnDate', label: 'Return Date' },
  // { key: 'depositRemark', label: 'Deposit Remark' },
  { key: 'projectManagerUser', label: 'Project Manager/Head BU' },
  { key: 'createdByName', label: 'Creator' }
]

export const columnsCompany = () => {
  return [
    {
      Header: 'Status',
      accessor: 'status',
      width: 100,
      Cell: row => (<DivText><StatusTag status={row.value} statusName={row.original.statusName} style={{background:statusColor[`${row.value}`]}}/></DivText>)
    }, 
    {
      Header: 'Document No.',
      accessor: 'documentNumber',
      width: 100,
      Cell: row => (<DivText>{row.value}</DivText>)
    }, 
    {
      Header: 'Document Type',
      accessor: 'documentType',
      width: 80,
      Cell: row => (<DivText>{pascalCase(row.value)}</DivText>)
    }, {
      Header: () => (<DivText left>Title</DivText>),
      accessor: 'title',
      width: 250
    }, {
      Header: 'Company',
      accessor: 'companyName',
      width: 100,
    }, {
      Header: 'Vendor/Customer',
      accessor: 'vendorCode',
      width: 120,
    }, {
      Header: 'Type of Bond',
      accessor: 'typeOfBond',
      width: 100,
      Cell: row => (<DivText>{titleCase(row.value)}</DivText>)
    }, {
      Header: 'Bank Guarantee No.',
      accessor: 'bankGuaranteeNumber',
      width: 100,
    }, {
      Header: 'Amount',
      accessor: 'amount',
      width: 100,
      style: { display: 'flex', justifyContent: 'flex-end' },
      Cell: row => numberFormat(row.value)
    }, {
      Header: 'Due date',
      accessor: 'dueDate',
      width: 120,
      Cell: row => (row.value && <DivText><Moment format='DD MMM YYYY'>{row.value}</Moment></DivText>)
    }, {
      Header: 'Created date',
      accessor: 'createdDate',
      width: 120,
      Cell: row => (row.value &&
        <DivText>
          {row.value ? <Moment format='DD MMM YYYY HH:mm'>{row.value}</Moment> : '-'}
        </DivText>)
    }
  ]
}